/**
 * UX fiche produit — vente au poids (Admin).
 * Présentation + défauts découpes. Pas de formule pricing / TVA métier.
 */

export const DECOUPE_CHECKBOX_KEYS = Object.freeze([
  'chiffonade',
  'fine',
  'normale',
  'epaisse',
]);

/**
 * Le bloc « Prix et tarification » (prix de base, promo, TVA) reste monté
 * même si la vente au poids est active. Ne plus lier au toggle.
 *
 * @param {boolean} showPrixSection
 * @param {boolean} [_venteAuPoids]
 * @returns {boolean}
 */
export function shouldMountPrixTarificationBlock(showPrixSection, _venteAuPoids) {
  return Boolean(showPrixSection);
}

/**
 * Prix de base / prix promo : visibles mais inactifs si le contrat poids
 * n’utilise pas ces montants (sauvegarde envoie toujours prix=0).
 *
 * @param {boolean} venteAuPoids
 * @returns {boolean}
 */
export function areClassicPriceInputsInactive(venteAuPoids) {
  return Boolean(venteAuPoids);
}

/**
 * TVA reste éditable en vente au poids (même logique métier, même options).
 *
 * @param {boolean} [_venteAuPoids]
 * @returns {boolean}
 */
export function isTvaEditableWithWeight(_venteAuPoids) {
  return true;
}

/**
 * Découpes après toggle vente au poids : ne jamais inventer Fine/Normale/Épaisse.
 * Tableau vide → reste vide. Sélection existante → préservée (ON et OFF).
 *
 * @param {unknown} currentDecoupes
 * @returns {string[]}
 */
export function nextDecoupesDisponiblesOnWeightToggle(currentDecoupes) {
  return Array.isArray(currentDecoupes) ? currentDecoupes.slice() : [];
}

/**
 * Chargement édition : restaurer exactement les découpes enregistrées.
 *
 * @param {{ decoupesDisponibles?: unknown } | null | undefined} produit
 * @returns {string[]}
 */
export function loadDecoupesDisponiblesFromProduit(produit) {
  return Array.isArray(produit?.decoupesDisponibles)
    ? produit.decoupesDisponibles.slice()
    : [];
}

/**
 * @param {string[] | unknown} decoupes
 * @param {string} key
 * @returns {boolean}
 */
export function isDecoupeChecked(decoupes, key) {
  return Array.isArray(decoupes) && decoupes.includes(key);
}

/**
 * Patch d’activation / désactivation du toggle (ne touche pas prix ni tauxTVA).
 *
 * @param {Record<string, unknown>} formData
 * @param {boolean} checked
 * @returns {Record<string, unknown>}
 */
export function applyVenteAuPoidsToggle(formData, checked) {
  return {
    ...formData,
    venteAuPoids: checked,
    prixAuPoids:
      checked && !formData.prixAuPoids ? formData.prix || '' : formData.prixAuPoids,
    poidsPortionStandard:
      checked && !formData.poidsPortionStandard ? 50 : formData.poidsPortionStandard,
    decoupesDisponibles: nextDecoupesDisponiblesOnWeightToggle(
      formData.decoupesDisponibles
    ),
  };
}

/**
 * Contrat de sauvegarde existant — inchangé :
 * venteAuPoids=true → prix catalogue envoyé à 0.
 *
 * @param {boolean} venteAuPoids
 * @param {number} convertedPrix
 * @returns {number}
 */
export function cataloguePrixSentOnSave(venteAuPoids, convertedPrix) {
  return venteAuPoids ? 0 : convertedPrix || 0;
}

/**
 * Classes Tailwind des champs prix classiques (grisés si inactifs).
 *
 * @param {boolean} venteAuPoids
 * @param {string} [baseClass]
 * @returns {string}
 */
export function classicPriceInputClassName(venteAuPoids, baseClass = '') {
  const inactive = areClassicPriceInputsInactive(venteAuPoids);
  const inactiveClass = inactive
    ? 'bg-gray-100 text-gray-500 cursor-not-allowed opacity-70'
    : '';
  return [baseClass, inactiveClass].filter(Boolean).join(' ');
}
